import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-auto" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex items-center content-center gap-2" }
const _hoisted_7 = { class: "bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "input-wrapper h-[60px] relative" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "flex items-center ml-[100px]" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, { size: 'max-w-xl' }, {
    maincontent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex flex-col justify-start text-start" }, [
                _createElementVNode("h2", { class: "font-semibold truncate text-single-line break-all mb-0.5 text-xl leading-6 mt-0 ml-2" }, "Add/Remove Cash")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"])),
                    class: "text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer hover:bg-white border border-white p-4 rounded hover:text-theme-green text-white ml-3"
                  }, "CANCEL"),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveAddCash && _ctx.saveAddCash(...args)), ["prevent"])),
                    class: "text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer bg-white p-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3"
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("span", null, "SAVE", -1)
                  ]))])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Adjustment Type", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      id: "cash",
                      name: "cash",
                      type: "radio",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.transactionType.value) = $event)),
                      value: "add cash",
                      class: "w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    }, null, 512), [
                      [_vModelRadio, _ctx.form.transactionType.value]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("label", {
                      for: "cash",
                      class: "ml-2 text-sm font-normal tracking-wider text-white dark:text-gray-300"
                    }, "Add Cash", -1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      id: "cash",
                      name: "cash",
                      type: "radio",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.transactionType.value) = $event)),
                      value: "remove cash",
                      class: "w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    }, null, 512), [
                      [_vModelRadio, _ctx.form.transactionType.value]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("label", {
                      for: "cash",
                      class: "ml-2 text-sm font-normal tracking-wider text-white dark:text-gray-300"
                    }, "Remove Cash", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: _normalizeClass(["mb-2", 'input-wrapper ' + (_ctx.form.amount.error_type)])
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Amount", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFields(['amount']))),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.amount.value) = $event)),
                    placeholder: "ei. $100.00",
                    class: "block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm",
                    type: "number"
                  }, null, 544), [
                    [_vModelText, _ctx.form.amount.value]
                  ]),
                  (_ctx.form.amount.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.amount.error_message)
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass(["relative", 'input-wrapper ' + (_ctx.form.note.error_type)])
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Notes", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateFields(['note']))),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.note.value) = $event)),
                  placeholder: "Add a note here",
                  class: "block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm"
                }, null, 544), [
                  [_vModelText, _ctx.form.note.value]
                ]),
                (_ctx.form.note.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.note.error_message)
                    }, null, 8, _hoisted_17))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}